<!-- @format -->

@let cpList = compareBarProducts$();
@let isCompareFeatureHidden = isCompareFeatureHidden$();
@let showSkeletonLoader = showSkeletonLoader$ | async;
@let displayableProductListData = dplData$ | async;
@let promoList = promoList$();
@let selectedStoreInfo = selectedStoreInfo$();
@let isAntiClearance = isAntiClearance$();
@let criteoProducts = criteoProducts$ | async;
@let customBadges = customBadges$();

@if (featureFlags().favoritesEnabled) {
	<shared-components-auth-snackbar [location]="'PLP'"></shared-components-auth-snackbar>
}

@if (isProductListPageLoading$() === false) {
	@if (isProductListPageValid$()) {
		<div
			id="plp-list-container"
			class="hmf-pb-m plp-list-container">
			<plp-components-product-list-header
				[productListData]="productListData()"
				[productListSEOData]="productListSEOData()"
				[isPlp3Template]="isPlp3Template()"></plp-components-product-list-header>
			@if (productListData()) {
					<plp-homr-components-template
						[chainAbbr]="chainAbbr()"
            [productListSEOData]="productListSEOData()">
          </plp-homr-components-template>
				@if (productListSEOData()?.categoryType !== 'C' && !showNoSearchResultsPage()) {
					<div
						id="plp-srlp-content-wrapper"
						class="hmf-grid">
						<!-- sticky top bar for desktop -->
						<div
							id="sticky-filter-container-desktop"
							class="sticky-filter-container-desktop hmf-display-flex hmf-flex-wrap hmf-position-sticky hmf-span-12"
							[ngClass]="{ 'hmf-elevated-shadow': isFilterContainerSticky() }">
							<div class="hmf-display-flex hmf-span-12">
								@if(!exposedFiltersEnabled()) {
										<!-- filter icon -->
										<div
											class="hmf-display-inline-flex hmf-align-items-center hmf-pl-s filter-container">
											<homefield-icon
												name="list-filter-alt"
												height="16px"
												width="16px"
												class="hmf-mr-xxs"></homefield-icon>
											<div
												class="hmf-text-transform-uppercase hmf-subheader-bold-m filter-label">
												Filter
											</div>
										</div>
									}
								<div class="shipping-exposed-filters-sort-container hmf-position-relative hmf-display-flex hmf-span-12 hmf-justify-content-between hmf-align-items-center hmf-flex-nowrap">
									<div class="scrollable-area-wrapper hmf-position-relative">
										@if(exposedFiltersEnabled()) {
											<shared-components-carousel-button
												class="hmf-display-block hmf-ml-xs hmf-ml-md-s carousel-button prev"
												[class.hmf-display-block]="showLeftArrow()"
												[previous]="true"
												[ariaLabel]="'Scroll Left'"
												[showLeftArrow]="showLeftArrow()"
												(clickEvent)="scrollFilters('left')">
											</shared-components-carousel-button>
											<shared-components-carousel-button
												class="hmf-display-block hmf-mr-xs hmf-mr-md-s carousel-button next"
												[class.hmf-display-block]="showRightArrow()"
												[previous]="false"
												[ariaLabel]="'Scroll Right'"
												[showRightArrow]="showRightArrow()"
												(clickEvent)="scrollFilters('right')">
											</shared-components-carousel-button>}
										<div #filtersShippingScrollableArea
											class="filters-container hmf-display-flex hmf-flex-nowrap hmf-flex-m-grow hmf-overflow-x-auto hide-scroll-bar
											hmf-justify-content-between hmf-align-items-center"
											(scroll)="onFilterScroll()">
											<!-- shipping options -->
											<plp-components-shipping-filter
												class="shipping-filters-desktop hmf-justify-content-flex-end hmf-align-items-center hmf-flex-m-grow hmf-ml-s hmf-ml-m-0"
												[disabled]="showSkeletonLoader"
												[sameDayDeliveryEnabled]="sameDayDeliveryEnabled()"
												[fulfillmentFacetsEnabled]="fulfillmentFacetsEnabled()"
												[exposedFiltersEnabled]="exposedFiltersEnabled()">
											</plp-components-shipping-filter>
											<!-- Exposed fileters -->
											@if(exposedFiltersEnabled()) {
												<div class="exposed-filters-divider hmf-m-xxs"></div>
												@for (
													filter of productListFacetVOs();
													let i = $index;
													track trackFilterName(i, filter)
													) 	{
														<plp-components-exposed-filters
														class="hmf-mx-xxxs"
														[filter]="filter"
														>
														</plp-components-exposed-filters>
													}
												}
										</div>
									</div>
									<!-- sort component -->
									<div
										class="hmf-display-flex hmf-justify-content-flex-end hmf-align-items-center hmf-ml-l sort-container sort-wrapper">
										<homefield-icon
											class="hmf-mr-xxxs"
											name="arrow-swap-vertical"
											width="16px"
											height="16px"></homefield-icon>
										<div class="hmf-py-xxs hmf-mr-xxs hmf-subheader-bold-m">
											SORT:
										</div>
										<plp-components-sort
											class="hmf-mr-xxs"
											[isDisabled]="showSkeletonLoader"
											[sortByCustomerRatingEnabled]="sortByCustomerRatingEnabled()"
											(tabPressed)="handleTabPressed()"></plp-components-sort>
									</div>
								</div>
							</div>
							<!-- compare bar -->
							@if (
								compareCheckboxEnabled() &&
								!isCompareFeatureHidden &&
								cpList?.length &&
								deviceBreakPoint() > BreakPointSizeEnum.MEDIUM
							) {
								<plp-components-compare-bar
									id="compare-bar-desktop"
									class="compare-bar-wrapper hmf-w-100"
									[showThumbnails]="true"
									[compareList]="cpList"></plp-components-compare-bar>
							}
						</div>

						<div class="hmf-grid product-grid-container">
							<div
								class="plp-srlp-filters hmf-display-none hmf-display-lg-block hmf-col hmf-px-0">
								<div class="hmf-position-relative">
									<div
										class="skip-to-product-listing hmf-position-absolute"
										[ngClass]="{
											'skip-to-product-listing__visible': skipLinkOpen()
										}">
										<button
											hmf-button
											variant="secondary"
											size="large"
											(keydown.enter)="onSkipLinkEnter($event)"
											(blur)="skipLinkOpen.set(false)">
											Skip to Product Listing
										</button>
									</div>
								</div>
								<!-- filter side bar for desktop -->
								@for (
									filter of productListFacetVOs();
									let i = $index;
									let isLast = $last;
									track trackFilterName(i, filter)
								) {
									<plp-components-filter
										ngSkipHydration
										[filter]="filter"
										[isMobile]="false"
										[isLast]="isLast"
										[disabled]="showSkeletonLoader"
										[defaultOpen]="
											openFacets() !== null && openFacets()[filter.attrName]
												? openFacets()[filter.attrName].open
												: false
										"
										[showMore]="
											openFacets() !== null &&
											openFacets()[filter.attrName]?.open
												? openFacets()[filter.attrName].showMore
												: false
										"
										[isPlp3Template]="isPlp3Template()"
										(keydown.tab)="tabKeyHandler(i)"
										(keydown.arrowup)="arrowUpKeyHandler($event)"
										(keydown.arrowdown)="arrowDownKeyHandler($event)"
										(facetToggled)="onFacetToggled($event)"
										(accordionFocused)="setCurrentFilterIndex(i)"
										(pressedSpaceOnCategoryItem)="
											focusFirstAccordion()
										"></plp-components-filter>
								}

								<!--Embedded Filters Survey-->
								@if (
									deviceBreakPoint() > BreakPointSizeEnum.MEDIUM &&
									featureFlags().plpFilterResultSurveyEnabled
								) {
									<div
										id="filter_emb_form"
										class="hmf-mb-l hmf-mt-s hmf-mx-xxs hmf-mx-m-s"></div>
								}

							</div>
							<div
								id="plp-grid"
								class="hmf-col hmf-px-0 hmf-span-12">
								<!-- sticky shipping filters -->
								<!-- deviceBreakPoint() <= BreakPointSizeEnum.MEDIUM is Tablet and Mobile -->
								<div
									id="sticky-filter-container-mobile"
									class="sticky-filter-container-mobile hmf-position-sticky hmf-position-lg-static hmf-display-flex hmf-align-items-center hmf-flex-wrap hmf-mt-0 hmf-my-lg-s"
									[ngClass]="{
										'no-filters-mobile':
											!isFulfillmentFiltersSelected() &&
											deviceBreakPoint() <= BreakPointSizeEnum.MEDIUM,
										'header-search-sticky-visible': isStickySearchEnabled(),
										'hmf-elevated-shadow': isFilterContainerSticky()
									}">
									<div
										class="filter-icon-shipping-options-wrapper hmf-display-flex hmf-span-12">
										<div
											class="sticky-filter-chip hmf-pt-xxs hmf-ml-xxxs hmf-ml-lg-s"
											[ngClass]="{
												'hmf-justify-content-end':
													displayableProductListData?.productListData?.length === 0,
												'hmf-position-absolute hmf-position-lg-relative':
													isFulfillmentFiltersSelected() && selectedStoreInfo
											}">
											<!-- mobile filter button when filters are not selected -->
											<div class="is-mobile">
												<hmf-side-panel
													class="common-side-nav"
													data-cy="add-to-cart-side-nav"
													modalName="Add to cart success"
													tabindex="0"
													[showSidePanel]="filtersOpen()"
													[width]="100"
													(sidePanelIsOpen)="filtersOpen.set($event)">
													<!-- panel header -->
													<div
														ngProjectAs="customPanelTitle"
														class="hmf-header-bold-xs">
														<homefield-icon
															class="hmf-mr-xxs"
															name="list-filter-alt"
															width="16px"
															height="16px"></homefield-icon>
														FILTER & SORT
													</div>
													<div
														class="filter-panel-body"
														ngProjectAs="customPanelBody">

														<div
															class="mobile-selected-filter"
															[ngClass]="{
																'hmf-display-none':
																	selectedFilterCount() === 0
															}">
															<plp-components-filter-chips
																[sameDayDeliveryEnabled]="
																	sameDayDeliveryEnabled()
																"></plp-components-filter-chips>
														</div>

														<div class="filter-container">
															@for (
																filter of productListFacetVOs();
																let i = $index;
																let isLast = $last;
																track trackFilterName(i, filter)
															) {
																<plp-components-filter
																	ngSkipHydration
																	[filter]="filter"
																	[isMobile]="true"
																	[isLast]="isLast"
																	[disabled]="showSkeletonLoader"
																	[defaultOpen]="
																		openFacets() !== null &&
																		openFacets()[
																			filter.attrName
																		]
																			? openFacets()[
																					filter.attrName
																				].open
																			: false
																	"
																	[showMore]="
																		openFacets() !== null &&
																		openFacets()[
																			filter.attrName
																		]?.open
																			? openFacets()[
																					filter.attrName
																				].showMore
																			: false
																	"
																	[isPlp3Template]="
																		isPlp3Template()
																	"
																	(keydown.tab)="tabKeyHandler(i)"
																	(keydown.arrowup)="
																		arrowUpKeyHandler($event)
																	"
																	(keydown.arrowdown)="
																		arrowDownKeyHandler($event)
																	"
																	(facetToggled)="
																		onFacetToggled($event)
																	"
																	(accordionFocused)="
																		setCurrentFilterIndex(i)
																	"
																	(pressedSpaceOnCategoryItem)="
																		focusFirstAccordion()
																	"></plp-components-filter>
															}

															<!--Embedded Filters Survey-->
															@if (
																deviceBreakPoint() <= BreakPointSizeEnum.MEDIUM &&
																featureFlags().plpFilterResultSurveyEnabled
															) {
																<div
																	id="filter_emb_form"
																	class="hmf-mt-s hmf-pb-s hmf-mx-s hmf-px-s"></div>
															}

														</div>
														<div
															class="bottom-button-container hmf-display-flex hmf-justify-content-between hmf-py-s">
															<button
																hmf-button
																class="hmf-ml-s hmf-mr-xxs"
																variant="secondary"
																title="Clear All"
																[text]="'Clear All'"
																[size]="'medium'"
																[disabled]="showSkeletonLoader"
																(click)="removeFilters()"></button>
															<button
																hmf-button
																class="hmf-ml-xxs hmf-mr-s"
																title="Show {{
																	productListData()?.searchVO
																		?.totalCount
																}}"
																variant="primary"
																text="Show {{
																	productListData()?.searchVO
																		?.totalCount
																}}"
																[size]="'medium'"
																(click)="
																	filtersOpen.set(false)
																"></button>
														</div>

													</div>
												</hmf-side-panel>
												<!-- mobile filter icon when filter is selected-->
												<button
													class="hmf-px-xxs hmf-py-xxxs hmf-display-flex hmf-flex-column hmf-align-items-center hmf-header-bold-xs hmf-ml-lg-s hmf-soft-radius filter-count-button hmf-position-relative"
													(click)="filtersOpen.set(true)">
													<homefield-icon
														name="list-filter-alt"></homefield-icon>
													@if (selectedFilterCount()) {
														<span class="filter-count hmf-position-absolute hmf-round-radius">
															{{ selectedFilterCount() }}
														</span>
													}
													<div
														class="hmf-pt-0 hmf-text-transform-uppercase filter-and-sort">
														Filter
													</div>
												</button>
											</div>
											@if (displayableProductListData?.productListData?.length) {
												<div
													class="filter-chip-slider-container hmf-display-flex hmf-align-items-center hmf-flex-nowrap hmf-flex-md-wrap">
													<div class="filter-chip-slider">
														<plp-components-filter-chips
															[sameDayDeliveryEnabled]="
																sameDayDeliveryEnabled()
															"></plp-components-filter-chips>
													</div>
												</div>
											}
											@if (!noProducts()) {
												<plp-components-top-pagination
													class="top-pagination"></plp-components-top-pagination>
											}
										</div>
										<div class="divider hmf-ml-xxs hmf-display-none"></div>
										<!-- sticky shipping filters for mobile -->
										<div class="is-mobile mobile-shipping-filter hide-scroll-bar">
											<plp-components-shipping-filter
												id="shipping-options"
												class="hmf-display-block hmf-display-sm-flex hmf-pt-xxxs hmf-pt-sm-0 hmf-my-m-0"
												[isMobile]="true"
												[filtersOpen]="filtersOpen()"
												[disabled]="showSkeletonLoader"
												[sameDayDeliveryEnabled]="sameDayDeliveryEnabled()"
												[fulfillmentFacetsEnabled]="fulfillmentFacetsEnabled()">
											</plp-components-shipping-filter>
										</div>
									</div>
							@if(!isFilterContainerSticky()){
								<div class="is-mobile exposed-filter-sort-mobile hmf-span-12">
									@if(exposedFiltersEnabled()) {
										<div class="exposed-filters-mobile hmf-display-flex hmf-flex-nowrap hmf-overflow-x-auto hide-scroll-bar">
											@for (
												filter of productListFacetVOs();
												let i = $index;
												track trackFilterName(i, filter)
												) 	{
														<plp-components-exposed-filters
															class="hmf-pl-xxs hmf-py-xxs"
															[filter]="filter"
														>
														</plp-components-exposed-filters>
													}
										</div>
									}

									<div
										id="on-page-sort-container"
										class="mobile-sort-wrapper hmf-py-xxxs hmf-display-flex hmf-w-100 hmf-px-xs hmf-align-items-center">
										<homefield-icon
											width="16px"
											height="16px"
											name="arrow-swap-vertical"></homefield-icon>
										<div class="hmf-pl-xxxs hmf-header-bold-xs">SORT:</div>
										<plp-components-sort
											[isDisabled]="showSkeletonLoader"
											[sortByCustomerRatingEnabled]="sortByCustomerRatingEnabled()"
											></plp-components-sort>
									</div>

								</div>}
								<!-- sticky filter button for mobile header -->

									@if (
										deviceBreakPoint() <= BreakPointSizeEnum.MEDIUM &&
										compareCheckboxEnabled() &&
										!isCompareFeatureHidden &&
										cpList?.length
									) {
										<plp-components-compare-bar
											id="compare-bar-mobile"
											class="is-mobile compare-bar-wrapper hmf-w-100"
											[compareList]="cpList"
											[showThumbnails]="false"
											[ngClass]="{
												'hmf-elevated-shadow': isFilterContainerSticky()
											}"></plp-components-compare-bar>
									}
								</div>
								@if (!noProducts()) {
									<plp-components-top-pagination
										class="is-mobile hmf-display-flex hmf-justify-content-flex-end hmf-pt-xs hmf-pb-xxs"></plp-components-top-pagination>
								}
								@if (showSkeletonLoader) {
									<div class="hmf-px-xs hmf-px-m-s plp-card-container">
										@for (item of loaderDummyArray(); track $index) {
											<shared-totf-components-skeleton-product-card
												class="product-card"
												[compareCheckboxEnabled]="
													compareCheckboxEnabled() &&
													!isCompareFeatureHidden
												"></shared-totf-components-skeleton-product-card>
										}
									</div>
								} @else {
									<div
										id="plp-container"
										class="hmf-px-xs hmf-px-m-s plp-card-container">
										@if (displayableProductListData?.productListData?.length > 0) {
											@for (
												plpProduct of displayableProductListData?.productListData;
												let i = $index;
												track trackDPLD(i, plpProduct)
											) {
												@if (
													(!plpProduct.isPinned ||
														(plpProduct.isPinned &&
															featureFlags().showPinnedProducts)) &&
													plpProduct.partnumber
												) {
													<div class="product-card hmf-position-relative">
														<shared-totf-components-product-card
															ngSkipHydration
															id="product-card-{{ i }}"
															referrer="{{ productCardReferrer() }}"
															[seoUrl]="
																plpProduct.assetSeoUrl ||
																plpProduct.dsgSeoUrl
															"
															[attributes]="plpProduct.attributes"
															[badge]="plpProduct.badge"
															[customBadge]="
																customBadges[
																	plpProduct.parentPartnumber
																]
															"
															[chainAbbr]="chainAbbr()"
															[colors]="
																plpProduct.skuAttributes?.Color
															"
															[dataEm]="
																'plp_' +
																(i + 1) +
																'_' +
																plpProduct.parentPartnumber +
																(plpProduct.isPinned
																	? '_pinned'
																	: '')
															"
															[ecode]="plpProduct.parentPartnumber"
															[isComingSoon]="plpProduct.isComingSoon"
															[mapPriceIndicator]="
																plpProduct.mapPriceIndicator
															"
															[priceIndicator]="
																plpProduct.priceIndicator
															"
															[prices]="
																plpProduct.prices | transformPrices
															"
															[productAvailabilityData]="
																availabilityList$()
																	?.ecodeMessagingMap?.[
																	plpProduct.parentPartnumber
																]
															"
															[productQuickViewEnabled]="
																plpProduct.quickViewEnabled
															"
															[promo]="
																promoList
																	? promoList[
																			plpProduct
																				.parentPartnumber
																		]
																		? promoList[
																				plpProduct
																					.parentPartnumber
																			].plpMessage
																		: promoList[
																				plpProduct?.parentCatentryId
																					? plpProduct?.parentCatentryId
																					: plpProduct?.catentryId
																			]?.promoDesc
																	: null
															"
															[selectedForCompare]="
																compareListEcodes()
																	| includes
																		: plpProduct.parentPartnumber
															"
															[compareBarProductsCount]="
																compareListEcodes().length
															"
															[selectedStoreName]="
																selectedStoreInfo?.name
															"
															[title]="plpProduct.name"
															[ratingValue]="
																plpProduct.ratingValue || 0
															"
															[ratingCount]="
																plpProduct.ratingCount || 0
															"
															[availabilityOnProductCardsEnabled]="
																showAvailabilityData()
															"
															[showCustomerRating]="
																plpShowCustomerRating()
															"
															[imageSwatchesEnabled]="
																useImageSwatches()
															"
															[isLCPImage]="
																i < MAX_NUMBER_ITEMS_PER_ROW
															"
															[isNgOptimizedImageSupported]="true"
															[isAntiClearance]="isAntiClearance"
															[categoryGroupId]="
																productListSEOData()?.catgroupId
															"
															[categoryIdentifier]="
																productListSEOData()?.identifier
															"
															[categoryType]="
																productListSEOData()?.categoryType
															"
															[compareCheckboxEnabled]="
																compareCheckboxEnabled() &&
																!isCompareFeatureHidden
															"
															(productCardClick)="
																recordClickEvent(
																	$event,
																	plpProduct,
																	i
																)
															"
															(compareCheckboxClick)="
																handleCompareSelection($event)
															">
														</shared-totf-components-product-card>

														@if (
															featureFlags().favoritesEnabled &&
															plpProduct.badge !== 'CustomizeIt' &&
															plpProduct.badge !==
																'PersonalizedItem' &&
															!nikeConnectedProducts().includes(
																plpProduct.parentPartnumber
															)
														) {
															<shared-favorites-components-auth-icon
																class="favorites-icon"
																[ecode]="
																	plpProduct.parentPartnumber
																"
																[location]="
																	FavoritesLocationEnum.PLP
																"
																[isAuthenticated]="
																	isAuthenticated()
																"></shared-favorites-components-auth-icon>
														}
													</div>
												}
												@if (
													featureFlags().showPinnedContent &&
													plpProduct.pinnedPosition
												) {
													<plp-components-pinned-content
														class="product-card hmf-pl-0"
														id="pinned-content-{{ i }}"
														[availabilityOnProductCardsEnabled]="
															showAvailabilityData()
														"
														[row]="
															(i / itemsPerRow() | dcsgMathFloor) + 1
														"
														[column]="(i % itemsPerRow()) + 1"
														[lazyLoad]="i >= MAX_NUMBER_ITEMS_PER_ROW"
														[imagePagePosition]="
															i >= MAX_NUMBER_ITEMS_PER_ROW
																? IMAGE_PAGE_POSITION_5
																: DEFAULT_IMAGE_PAGE_POSITION
														"
														[pinnedContent]="plpProduct"
														[showCustomerRating]="
															plpShowCustomerRating()
														">
													</plp-components-pinned-content>
												}
												@if (
													featureFlags().showPLPSponsoredProducts &&
													plpProduct.sponsored &&
													sortingByValidValues()
												) {
													<div class="hmf-position-relative">
														<shared-totf-components-product-card
															ngSkipHydration
															id="sponsored-product-{{ i }}"
															class="product-card criteo-{{
																plpProduct.product.ID
															}}"
															referrer="{{ productCardReferrer() }}"
															[addColorToProductUrl]="false"
															[clickTrackerUrl]="
																plpProduct.click_tracker
															"
															[basketChangeBeacon]="
																plpProduct.onBasketChangeBeacon
															"
															[seoUrl]="plpProduct.product.URL"
															[badge]="
																showNewSponsoredLabel()
																	? plpProduct.badge
																	: 'Sponsored'
															"
															[isSponsored]="true"
															[isCriteo]="plpProduct.isCriteo"
															[chainAbbr]="chainAbbr()"
															[colors]="plpProduct.product.Color"
															[dataEm]="
																'plp_' +
																(i + 1) +
																'_' +
																plpProduct.product.ImageURL +
																'_sponsored'
															"
															[ecode]="plpProduct.product_id"
															[imageUrl]="
																plpProduct.product.ImageURL +
																'&wid=252&hei=252&qlt=85,0&fmt=jpg&op_sharpen=1'
															"
															[isComingSoon]="plpProduct.isComingSoon"
															[mapPriceIndicator]="
																plpProduct.product.mapPriceIndicator
															"
															[priceIndicator]="
																plpProduct.product.maxofferprice <
																	plpProduct.product
																		.maxlistprice ||
																plpProduct.product.minofferprice <
																	plpProduct.product.minlistprice
																	? 0
																	: 1
															"
															[prices]="
																{
																	minofferprice:
																		plpProduct.product
																			.minofferprice,
																	maxofferprice:
																		plpProduct.product
																			.maxofferprice,
																	minlistprice:
																		plpProduct.product
																			.minlistprice,
																	maxlistprice:
																		plpProduct.product
																			.maxlistprice
																} | transformPrices
															"
															[selectedForCompare]="
																compareListEcodes()
																	| includes
																		: plpProduct.product_id
															"
															[productAvailabilityData]="
																availabilityList$()
																	?.ecodeMessagingMap?.[
																	plpProduct.product_id
																]
															"
															[productQuickViewEnabled]="true"
															[selectedStoreName]="
																selectedStoreInfo?.name
															"
															[title]="plpProduct.product.Name"
															[showNewSponsoredLabel]="
																showNewSponsoredLabel()
															"
															[showCustomerRating]="
																plpShowCustomerRating()
															"
															[imageSwatchesEnabled]="
																useImageSwatches()
															"
															[isAntiClearance]="isAntiClearance"
															[categoryGroupId]="
																productListSEOData()?.catgroupId
															"
															[categoryIdentifier]="
																productListSEOData()?.identifier
															"
															[categoryType]="
																productListSEOData()?.categoryType
															"
															(productCardClick)="
																recordClickEvent(
																	$event,
																	plpProduct,
																	i
																)
															"
															[availabilityOnProductCardsEnabled]="
																showAvailabilityData()
															"
															[compareCheckboxEnabled]="
																compareCheckboxEnabled() &&
																!isCompareFeatureHidden
															"
															(compareCheckboxClick)="
																handleCompareSelection($event)
															">
														</shared-totf-components-product-card>
														<shared-favorites-components-auth-icon
															class="favorites-icon"
															[ecode]="plpProduct.product_id"
															[location]="FavoritesLocationEnum.PLP"
															[isAuthenticated]="isAuthenticated()"
															[onWishlistBeacon]="
																plpProduct.onWishlistBeacon
															"></shared-favorites-components-auth-icon>
													</div>
												}
											}
											@defer (on idle) {
												@if (featureFlags().plpGoogleAdManagerEnabled) {
													<shared-components-google-ad-manager
														class="ad-manager ad-manager-grid"
														[data]="'grid_banner'"
														[showSponsoredLabel]="true"
														[enableTooltipSurvey]="
															enableTooltipSurvey()
														"></shared-components-google-ad-manager>
												}
											} @placeholder {
                        <div></div>
                      }
										} @else {
											<plp-components-no-filtered-results
												ngSkipHydration
												class="hmf-pl-xxs hmf-pt-xxs"></plp-components-no-filtered-results>
										}
									</div>
								}
								@if (!noProducts()) {
									<plp-components-bottom-pagination></plp-components-bottom-pagination>
								}

								<!--Embedded Searching Survey-->
								@if (
									pageType() === 'srlp' &&
									featureFlags().plpSearchResultSurveyEnabled
								) {
									<div
										id="satisfaction_emb_form"
										class="hmf-mb-l hmf-mx-xxs hmf-mx-m-s"></div>
								}
							</div>
							<!-- end main grid right col-->
						</div>
					</div>
				} @else {
					<plp-components-color-breakout
						ngSkipHydration
						class="breakout-grid"></plp-components-color-breakout>
				}
			}

			@defer (on viewport; prefetch on idle) {
				<div class="hmf-mt-m-xxl hmf-mt-xl hmf-grid recommend-container">
					<!-- Certona Recommendations 'Recently Viewed' -->
					@if (pageType() === 'plp') {
						<div
							id="family1_rr"
							class="hmf-col hmf-span-12 product-cross-sells-1">
							<shared-components-product-recommendations
								displayName="Recently Viewed"
								schemes="schemes"
								[filterBy]="scheme2"
								[showViewMoreLink]="false"
								[isPLPRecs]="true"
								[showQVButtons]="true"
								[pageType]="
									pageType()
								"></shared-components-product-recommendations>
						</div>
					}
					<!-- end 'Recently Viewed'-->
					@if (showNoSearchResultsPage()) {
						<div class="hmf-col hmf-span-12">
							<shared-components-product-recommendations
								displayName="You May Also Like"
								schemes="schemes"
								filterBy="nosearch_rr"
								[showViewMoreLink]="false"
								[isPLPRecs]="true"
								[pageType]="
									pageType()
								"></shared-components-product-recommendations>
							<shared-components-product-recommendations
								displayName="Recently Viewed"
								schemes="schemes"
								filterBy="nosearch1_rr"
								[showViewMoreLink]="false"
								[isPLPRecs]="true"
								[showQVButtons]="true"
								[pageType]="
									pageType()
								"></shared-components-product-recommendations>
							<shared-components-product-recommendations
								displayName="Top Categories For You"
								schemes="schemes"
								filterBy="contentsearch1_rr"
								[showViewMoreLink]="false"
								[isPLPRecs]="true"
								[pageType]="
									pageType()
								"></shared-components-product-recommendations>
						</div>
					}

					<!-- SRPL Certona Recommendations -->
					<!--'Recently Viewed' -->
					@if (pageType() === 'srlp') {
						<div class="hmf-col hmf-span-12">
							<shared-components-product-recommendations
								displayName="Recently Viewed"
								schemes="schemes"
								filterBy="search_rr"
								[showViewMoreLink]="false"
								[isPLPRecs]="true"
								[showQVButtons]="true"
								[pageType]="
									pageType()
								"></shared-components-product-recommendations>
						</div>
					}

					<!-- Sponsored Products -->
					@if (
						featureFlags().showPLPSponsoredProducts ||
						featureFlags().isUsingCriteoSPAAdServer
					) {
						<div
							id="contentsearch1_rr"
							class="hmf-col hmf-span-12 product-cross-sells-1 hmf-px-0 hmf-px-m-xs">
							@if (
								criteoProducts?.placements[0]?.carousel[0]?.products?.length > 0
							) {
								<shared-components-product-recommendations
									displayName="Must-Have Picks"
									[sponsored]="true"
									[showViewMoreLink]="false"
									[criteoProducts]="criteoProducts"
									[isPLPRecs]="true"
									[catgroupId]="productListSEOData()?.catgroupId"
									[chainAbbr]="chainAbbr()"
									[homefieldCarouselEnabled]="true">
								</shared-components-product-recommendations>
							}
						</div>
					}
					<!--end Sponsored Products -->
				</div>
			} @placeholder {
				<div></div>
			}

			@defer (on idle) {
				@if (featureFlags().plpGoogleAdManagerEnabled) {
					<shared-components-google-ad-manager
						class="ad-manager hmf-px-xxs hmf-px-m-xs"
						[data]="'bottom_banner'"
						[showSponsoredLabel]="true"
						[enableTooltipSurvey]="
							enableTooltipSurvey()
						"></shared-components-google-ad-manager>
				}
			}

			<!-- Common PRO-TIPS -->
			@if (featureFlags().isPLPProTipsEnabled) {
				<div class="plp-srlp-common-pro-tips-container hmf-pt-xxl">
					<shared-component-pro-tips [category]="productListSEOData()?.seoUrl">
					</shared-component-pro-tips>
				</div>
			}
			@if (productListSEOData()) {
				<shared-components-seo-content
					[productListSEOData]="productListSEOData()">
				</shared-components-seo-content>
			}
		</div>
		<!-- end plp-list-container -->
	} @else {
		<plp-components-not-found></plp-components-not-found>
	}
} @else {
	<div class="plp-page-loading-content">
		<img
			src="assets/image/dsgspinner.svg"
			aria-hidden="true"
			alt="dsg spinner" />
	</div>
}
